export default "__VITE_ASSET__CN6W9dn5__"